import { laborClassificationsActions } from './laborClassificationsSlice';
import projectTypesActions from 'store/projectTypes/projectTypesActions';


export const lcCreatedHandler = (store) => (data) => {
  if (!data?._id) return;
  store.dispatch(laborClassificationsActions.lcCreated(data));
};

export const lcUpdatedHandler = (store) => (data) => {
  if (!data?._id) return;
  store.dispatch(laborClassificationsActions.lcRenamed(data));
};

// BE detaches the LC from projects server-side without a projects:updated event
export const applyLcDeletedToCaches = (store, data) => {
  if (!data?._id) return;
  store.dispatch(laborClassificationsActions.lcSoftDeleted(data));
  store.dispatch(projectTypesActions.detachLaborClassification(data._id));
};
